import ConsumerHeader from '@/components/consumerHeader'
import { Box, Tab } from '@mui/material'
import { Tabs } from '@mui/material'
import { useState, useMemo, useEffect } from 'react'
import { useParams, useNavigate, Outlet } from 'react-router-dom'

function SensorsDetailsLayout() {
  const { siteId, sensorId } = useParams()
  const [value, setValue] = useState(0)
  const navigate = useNavigate()
  const handleChange = (_: unknown, newValue: number) => {
    setValue(newValue)
    navigate(`/sensors/${sensorId}/${options[newValue].route}`)
  }
  useEffect(() => {
    const path = location.pathname.split('/').pop()
    const index = options.findIndex(option => option.route === path)
    setValue(index)
  }, [])
  const options = useMemo(
    () => [
      { label: 'פרטי יחידת קצה', value: 0, route: 'details' },
      { label: 'ערכים', value: 1, route: `calls` },
      { label: 'התראות', value: 2, route: `notifications` },
      { label: 'היסטוריה החלפות', value: 3, route: `history` },
      { label: 'CRM', value: 4, route: `crm` },
      { label: 'מבט כללי', value: 5, route: `general` },
    ],
    []
  )
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
        paddingTop: '16px',
        paddingBottom: '8px',
        paddingRight: '16px',
        paddingLeft: '30px',
      }}
    >
      <ConsumerHeader title={sensorId || ''} backTo={`/${siteId}/sensors`} />
      <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop: '12px' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          sx={{
            direction: 'rtl',
            '& .MuiTabs-indicator': {
              backgroundColor: '#72A4EB',
              height: '3px',
            },
          }}
        >
          {options.map(option => (
            <Tab
              key={option.value}
              sx={{ outline: 'none !important', color: '#003F61 !important' }}
              label={option.label}
              value={option.value}
            />
          ))}
        </Tabs>
      </Box>
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  )
}

export default SensorsDetailsLayout
